import React from 'react';
import { Link } from 'react-router-dom';
import { productCategories } from '../data/mock';
import { Wheat, Cloud, CircleDot } from 'lucide-react';

const iconMap = {
  wheat: Wheat,
  cloud: Cloud,
  'circle-dot': CircleDot,
};

const ProductCategories = () => {
  return (
    <section className="py-8 px-4 bg-white">
      <div className="max-w-4xl mx-auto">
        <div className="grid grid-cols-3 gap-4">
          {productCategories.map((category) => {
            const IconComponent = iconMap[category.icon];
            return (
              <Link
                key={category.id}
                to={category.href}
                className="group flex flex-col items-center justify-center p-6 bg-[#FFDA00] rounded-lg shadow-md hover:shadow-lg transition-all duration-300 hover:-translate-y-1"
              >
                <div className="w-16 h-16 mb-3 flex items-center justify-center bg-white/20 rounded-full group-hover:bg-white/30 transition-colors duration-200">
                  {IconComponent && (
                    <IconComponent
                      size={32}
                      className="text-white"
                    />
                  )}
                </div>
                <span className="text-white font-semibold text-lg">
                  {category.name}
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ProductCategories;
